import { createContext } from 'react';
import { YiluOverrides } from 'types';

export const ComponentOverridesContext = createContext<Partial<YiluOverrides> | undefined>(
  undefined,
);
